/* Me & My Activewear — no-app wishlist (browser localStorage).
   Denormalised: each saved item stores handle/title/url/image/price so the
   wishlist page renders with no network calls. If you later add a wishlist
   app for cross-device sync, keep the [data-mm-wish] buttons and swap the
   read/write functions below for the app's API. */
(function () {
  var KEY = 'mm_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }
  function toggle(data) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === data.handle; });
    if (idx > -1) { list.splice(idx, 1); } else { list.unshift(data); }
    write(list);
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function syncButtons() {
    document.querySelectorAll('[data-mm-wish]').forEach(function (btn) {
      btn.classList.toggle('is-active', has(btn.getAttribute('data-handle')));
    });
    var c = read().length;
    document.querySelectorAll('[data-mm-wish-count]').forEach(function (el) {
      el.textContent = c;
      el.hidden = c === 0;
    });
  }

  function renderPage() {
    var root = document.getElementById('mm-wishlist-root');
    if (!root) return;
    var list = read();
    var empty = document.getElementById('mm-wishlist-empty');
    if (!list.length) {
      root.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    root.innerHTML = list.map(function (i) {
      return '' +
        '<div class="mm-wish-card">' +
          '<a class="mm-wish-card__media" href="' + esc(i.url) + '">' +
            (i.image ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="mm-wish-remove" data-mm-wish data-handle="' + esc(i.handle) + '" aria-label="Remove from wishlist">&times;</button>' +
          '<a class="mm-wish-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
          '<div class="mm-wish-card__price">' + esc(i.price) + '</div>' +
        '</div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mm-wish]');
    if (!btn) return;
    e.preventDefault();
    toggle({
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price')
    });
    syncButtons();
    renderPage();
  });

  function boot() { syncButtons(); renderPage(); }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);

  window.MMWishlist = { read: read, syncButtons: syncButtons };
})();
